const unavailable='Serveren svarede ikke i tide. Prøv igen.';
const invalid='Serveren gav et ugyldigt svar. Prøv igen.';

// A proxy timeout can return HTML. Never expose its body as a JSON/parser error.
export async function readAdminResponse(response){
 let data;
 try{data=JSON.parse(await response.text());}catch{
  if(response.status===401)return {error:'admin_required'};
  throw new Error([408,502,503,504].includes(response.status)?unavailable:invalid);
 }
 if(data===null||typeof data!=='object')throw new Error(invalid);
 return data;
}

export function adminTransportError(error){
 if(error?.name==='TimeoutError'||error?.name==='AbortError')return new Error(unavailable);
 if(error instanceof TypeError)return new Error('Forbindelsen til serveren kunne ikke oprettes. Prøv igen.');
 return error;
}

export function operationsMeasurementState(status,{error='',busy=false}={}){
 if(status===null)return error?'unavailable':'loading';
 if(!status.latest)return 'empty';
 return status.stale?'stale':'current';
}
